export enum MetricUnit {
  Amount = 'Amount',
  Quantity = 'Quantity',
  Quality = 'Quality'
}
